export default __webpack_public_path__ + "static/performanceSection4_img3-67d63a9939b5d0b58c5b0b6d82d3489b.png";